// extracted by mini-css-extract-plugin
module.exports = {"content":"app_content__ckDFI","detail":"app_detail__Xmsnl","list":"app_list__2we4s"};